import { inject, Injectable } from '@angular/core';
import { ICreateAction } from '@principle-theorem/ng-interactions';
import { ReferralService } from './referral.service';
import { REFERRALS_FEATURE } from '@principle-theorem/principle-core/features';

@Injectable({
  providedIn: 'root',
})
export class CreateReferralActionService implements ICreateAction {
  private _referralService = inject(ReferralService);

  readonly icon = 'add';
  readonly name = 'New Referral';
  readonly featureFlag = REFERRALS_FEATURE;

  async do(): Promise<void> {
    await this._referralService.openCreateDialog();
  }
}
